export default __webpack_public_path__ + "static/media/secureAndSimple.73ef6538.png";